import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Database } from '@/integrations/supabase/types';

type MinutePackage = Database['public']['Tables']['minute_packages']['Row'];

interface UseMinutePackagesOptions {
  onlyActive?: boolean;
  currency?: string;
  orderBy?: {
    column: keyof MinutePackage;
    ascending?: boolean;
  };
}

export const useMinutePackages = ({
  onlyActive = true,
  currency,
  orderBy = { column: 'sort_order', ascending: true }
}: UseMinutePackagesOptions = {}) => {
  return useQuery({
    queryKey: ['minute-packages', onlyActive, currency, orderBy],
    queryFn: async () => {
      let query = supabase
        .from('minute_packages')
        .select('*');

      if (onlyActive) {
        query = query.eq('is_active', true);
      }

      if (currency) {
        query = query.eq('currency', currency);
      }

      const { data, error } = await query.order(orderBy.column, { ascending: orderBy.ascending });

      if (error) {
        throw error;
      }

      return data.map((pkg) => ({
        id: pkg.id,
        title: pkg.title,
        titleKey: pkg.title_key,
        minutesAmount: pkg.minutes_amount,
        price: pkg.price,
        description: pkg.description,
        isActive: pkg.is_active,
        isPopular: pkg.is_popular,
        sortOrder: pkg.sort_order,
        currency: pkg.currency,
        createdAt: pkg.created_at,
        updatedAt: pkg.updated_at
      }));
    }
  });
};

// Тип возвращаемых данных
export type FormattedMinutePackage = ReturnType<typeof useMinutePackages>['data'][number];